import ArchiveIssueModal from './async';
import { useArchiveIssueModalActions, useArchiveIssueModalStates } from './controllers';

export default ArchiveIssueModal;
export { useArchiveIssueModalActions, useArchiveIssueModalStates };
